import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const FAKE_BUYERS = [{
  name: 'Martín G.',
  city: 'Buenos Aires'
}, {
  name: 'Lucía R.',
  city: 'Córdoba'
}, {
  name: 'Diego F.',
  city: 'Rosario'
}, {
  name: 'Valentina M.',
  city: 'Mendoza'
}, {
  name: 'Sebastián T.',
  city: 'Mar del Plata'
}, {
  name: 'Carolina P.',
  city: 'La Plata'
}, {
  name: 'Andrés L.',
  city: 'Tucumán'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(FAKE_BUYERS[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const showPopup = () => {
      // Pick random buyer
      const randomBuyer = FAKE_BUYERS[Math.floor(Math.random() * FAKE_BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next popup (random between 15-30s)
        const nextInterval = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
        setTimeout(showPopup, nextInterval);
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-27">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full bg-zinc-900 border-l-4 border-yellow-500 rounded-lg shadow-2xl p-3 flex items-center gap-3" data-id="element-28">
          <div className="h-10 w-10 rounded-full bg-yellow-500 flex items-center justify-center flex-shrink-0" data-id="element-29">
            <span className="font-bold text-black text-lg" data-id="element-30">
              {currentBuyer.name.charAt(0)}
            </span>
          </div>
          <div className="flex-1 min-w-0" data-id="element-31">
            <div className="flex items-center gap-1 mb-0.5" data-id="element-32">
              <CheckCircle2 className="w-3 h-3 text-green-500" data-id="element-33" />
              <span className="text-[10px] font-bold text-green-500 uppercase tracking-wider" data-id="element-34">
                Compra verificada
              </span>
            </div>
            <p className="text-xs text-white font-medium truncate" data-id="element-35">
              <span className="font-bold text-yellow-500" data-id="element-36">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-400 truncate" data-id="element-37">
              acaba de adquirir Códigos Ocultos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}